import { createSlice } from '@reduxjs/toolkit';

import { CurrentFlag } from 'entities/CurrentFlag';
import { AppError } from 'entities/Errors';

import { getCurrentFlagList } from './current_flag.action';

interface CurrentFlagState {
  loading: boolean;
  error: null | AppError;
  currentFlagList: CurrentFlag[];
}

const initialState = {
  loading: false,
  error: null,
  currentFlagList: [],
} as CurrentFlagState;

export const currentFlagSlice = createSlice({
  name: 'currentFlag',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getCurrentFlagList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.currentFlagList = [];
      })
      .addCase(getCurrentFlagList.fulfilled, (state, action) => {
        state.loading = false;
        state.currentFlagList = action.payload.data;
      })
      .addCase(getCurrentFlagList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default currentFlagSlice.reducer;
